/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PatchApiV1PersonIdActivateMutationResponse,
  PatchApiV1PersonIdActivatePathParams,
  PatchApiV1PersonIdActivate401,
  PatchApiV1PersonIdActivate404,
  PatchApiV1PersonIdActivate500,
} from "../../types/personRegisterController/PatchApiV1PersonIdActivate.ts";

function getPatchApiV1PersonIdActivateUrl(
  id: PatchApiV1PersonIdActivatePathParams["id"],
) {
  const res = {
    method: "PATCH",
    url: `/api/v1/person/${id}/activate` as const,
  };
  return res;
}

/**
 * @description Reativa uma pessoa que foi desativada. **(Requer Authorization para autenticação)**
 * @summary Ativar pessoa (Requer Authorization para autenticação)
 * {@link /api/v1/person/:id/activate}
 */
export async function patchApiV1PersonIdActivate(
  id: PatchApiV1PersonIdActivatePathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    PatchApiV1PersonIdActivateMutationResponse,
    ResponseErrorConfig<
      | PatchApiV1PersonIdActivate401
      | PatchApiV1PersonIdActivate404
      | PatchApiV1PersonIdActivate500
    >,
    unknown
  >({
    method: "PATCH",
    url: getPatchApiV1PersonIdActivateUrl(id).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
